/* import __COLOCATED_TEMPLATE__ from './webhook-failure-title.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();